import React from 'react';
import DownQuote from '../../../shared/icons/DownQuote';

const DownQuoteMarkAtom = () => (
  <DownQuote />
);

export default DownQuoteMarkAtom;
